import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react'
import { ProcessFlowDiagramBuilderContext } from 'features/processFlowDiagrams/contexts/ProcessFlowDiagramBuilderContext'
import React, { useContext } from 'react'
import { PfdEdgeProps } from 'types'

import { SwapEdgeButton } from './SwapEdgeButton'

export const DEFAULT_EDGE_STROKE_WIDTH = 3

export const EDGE_LABEL_STYLE: React.CSSProperties = {
  fontSize: '0.625rem',
  fontWeight: 500,
  color: '#e0e0e0',
}

export const EDGE_LABEL_BG_STYLE: React.CSSProperties = {
  fill: '#2a2a2a',
  fillOpacity: 0.9,
  rx: 3,
  ry: 3,
}

export const getEdgeSelectionStyle = (
  isSelected: boolean,
  baseStyle: React.CSSProperties
): React.CSSProperties => {
  return isSelected
    ? {
        ...baseStyle,
        strokeWidth: 3,
        stroke: '#007bff',
        strokeOpacity: 0.8,
      }
    : baseStyle
}

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {
    strokeWidth: 1,
    stroke: 'gray',
  },
  markerEnd,
  markerStart,
  data,
}: PfdEdgeProps) {
  const { selectedEdge } = useContext(ProcessFlowDiagramBuilderContext)
  const selected = selectedEdge?.id === id
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    stepPosition: 1,
    borderRadius: 0,
  })

  const baseStyle: React.CSSProperties = {
    ...style,
    strokeWidth: data?.strokeWidth ?? DEFAULT_EDGE_STROKE_WIDTH,
  }
  const edgeStyle = getEdgeSelectionStyle(selected, baseStyle)

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={edgeStyle}
        label={data?.label}
        labelStyle={data?.label ? EDGE_LABEL_STYLE : undefined}
        labelBgStyle={data?.label ? EDGE_LABEL_BG_STYLE : undefined}
        labelBgPadding={data?.label ? [4, 6] : undefined}
        labelX={labelX}
        labelY={labelY}
      />
      {!data?.confirmedEdge && (
        <EdgeLabelRenderer>
          <SwapEdgeButton labelX={labelX} labelY={labelY} id={id} />
        </EdgeLabelRenderer>
      )}
    </>
  )
}
